import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AFEntity } from '../model/af.model';
import { AuthService } from '../service/auth.service';
import { EventService } from '../service/event.service';
import { ShowLoaderEvent } from '../service/events';

@Injectable({
  providedIn: 'root'
})

export class AuthguardMain {

  constructor(private userService: AuthService, private router: Router, private eventBus: EventService) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const verifyId: string = route.queryParams['verifyId'];

    if (verifyId != null) {
      sessionStorage.setItem('verifyId', verifyId);
      localStorage.setItem('verifyIdLocal', verifyId);
      localStorage.setItem('loginType', "1");
    } else if (this.userService.getVerifyId() == null) {
      this.router.navigate(['unauthorized']);
    }

    this.eventBus.emit(new ShowLoaderEvent({ show: false }));
    this.userService.getApplicantDetails(false).subscribe({
      next: (data: AFEntity) => {
        sessionStorage.setItem(environment.user_object, JSON.stringify(data));

        if (data.skinnyFlag === 1) {
          localStorage.setItem('skinnyForm', '1');
        }

        this.eventBus.emit(new ShowLoaderEvent({ show: true }));
        if (data.view == "signInView") {
          this.router.navigate(['login']);
        } else if (data.view == "registrationView") {
          this.router.navigate(['createAccount']);
        } else if (data.view == "accountLockedView") {
          this.router.navigate(['accountLocked']);
        } else {
          this.router.navigate(['unauthorized']);
        }
      },
      error: (error: Error) => {
        console.log("Error loading applicant: ", error);
        this.router.navigate(['unauthorized']);
        this.eventBus.emit(new ShowLoaderEvent({ show: true }));
      }
    });

    return true;
  }
}
